import { Component } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { ContainerComponent } from '../../../shared/components/container/container.component';
import { GlobalButtonComponent } from '../../../shared/components/global-button/global-button.component';
import { PictureComponent } from '../../../shared/components/picture/picture.component';

@Component({
  selector: '[how-can-screen]',
  imports: [
    NgTemplateOutlet,
    ContainerComponent,
    GlobalButtonComponent,
    PictureComponent,
  ],
  templateUrl: './how-can-screen.component.html',
  styleUrl: './how-can-screen.component.scss',
  host: {
    class: 'text-dark',
  },
})
export class HowCanScreenComponent {
  card1Button1 = {
    buttonLabel: 'Request screening',
    buttonUrl: 'https://type1test.labpass.com/en/welcome',
    openInNewTab: true,
    buttonIcon: 'right-icon',
    interstitialLong: true,
  };

  // card1Button2 = {
  //   buttonType: 'transparent-purple',
  //   buttonLabel: 'Learn more below',
  //   buttonUrl: '',
  //   openInNewTab: false,
  //   buttonIcon: 'right-icon',
  // };

  card2Button1 = {
    buttonLabel: 'Request screening',
    buttonUrl:
      '/assets/pdf/type-1-diabetes-screening-doctor-discussion-guide-mobile.pdf',
    openInNewTab: true,
    buttonIcon: 'right-icon',
  };

  card2Button1Desk = {
    buttonLabel: 'Request screening',
    buttonUrl:
      '/assets/pdf/type-1-diabetes-screening-doctor-discussion-guide.pdf',
    openInNewTab: true,
    buttonIcon: 'right-icon',
  };

  card2Button2 = {
    buttonType: 'transparent-purple',
    buttonLabel: 'View video',
    buttonUrl: '',
    openInNewTab: false,
    buttonIcon: 'right-icon',
    videoAdam: true,
  };

  card3Button1 = {
    buttonLabel: 'Visit ASK',
    buttonUrl: 'https://www.askhealth.org',
    openInNewTab: true,
    buttonIcon: 'right-icon',
    interstitial: true,
  };

  card3Button2 = {
    buttonLabel: 'Visit TrialNet',
    buttonUrl: 'https://www.trialnet.org/participate',
    openInNewTab: true,
    buttonIcon: 'right-icon',
    interstitial: true,
  };

  card4Button1 = {
    buttonLabel: 'Get more info',
    buttonUrl: 'https://www.questhealth.com',
    openInNewTab: true,
    buttonIcon: 'right-icon',
    interstitial: true,
  };
}
